import pimg1 from '../images/event/1.jpg'
import pimg2 from '../images/event/2.jpg'
import pimg3 from '../images/event/3.jpg'

import psimg1 from '../images/events-single/1.jpg'
import psimg2 from '../images/events-single/2.jpg'
import psimg3 from '../images/events-single/3.jpg'



const events = [
    {
        id: '1',
        title: 'School For African Poor Children',
        slug: '1',
        pimg: pimg1,
        psimg: psimg1,
        time: '4:00pm-6:00pm',
        day:"22",
        location: 'New York',
        manth:"janu"
    },
    {
        id: '2',
        title: 'Solve the Water Problem of World ',
        slug: '2',
        pimg: pimg2,
        psimg: psimg2,
        time: '4:00pm-6:00pm',
        day:"25",
        location: 'United Arab',
        manth: "Fab"
    },
    {
        id: '3',
        title: 'Your Old Clothes are Their Happiness.',
        slug: '3',
        pimg: pimg3,
        psimg: psimg3,
        time: '4:00pm-6:00pm',
        day:"28",
        location: 'Singapore',
        manth: "March"
    },
    

]
export default events;